import { AiFillEdit, AiFillDelete, AiFillEye, AiOutlineSwap } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import helpers from "utils/helpers";

// ═══ Add getShiftColor to props ═══
const ShiftList = ({ shiftList, page, handleEdit, handleView, handleDelete, getShiftColor }) => {
  const { t } = useTranslation();

  // Helper to determine text color based on background brightness
  const getTextColor = (bgColor) => {
    // If it's a dark color, return white text, else dark text
    // For our pastel colors, text-gray-800 (dark) works best
    return 'text-gray-800';
  };

  return (
    <div>
      <div className="p-3">
        <div className="border overflow-x-auto relative rounded-lg">
          <table className="text-left w-full text-xs text-[#A5A5A5] dark:text-gray-400">
            <thead className="text-gray-900 text-xs border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-5">{t("EMPLOYEE")}</th>
                <th scope="col" className="px-5 py-3">{t("SHIFT_NAME")}</th>
                <th scope="col" className="py-3 px-5">{t("LOCATION")}</th>
                <th scope="col" className="text-center py-3 px-5">{t("STATUS")}</th>
                <th className="py-3 px-5" scope="col">{t("DATE")}</th>
                {/* <th scope="col" className="py-3 px-5">{t("TIME")}</th> */}
                <th scope="col" className="text-center py-3 px-5">{t("O_CREATED_AT")}</th>
                <th className="py-3 px-5 text-center" scope="col">{t("O_ACTION")}</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(shiftList) && shiftList?.map((item, i) => {
                // ═══ Get the color for this shift name ═══
                const shiftName = item?.name || "Unknown";
                const bgColor = getShiftColor ? getShiftColor(shiftName) : '#F3F4F6';
                const textColor = getTextColor(bgColor);

                return (
                  <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <td className="py-5 px-5 border-r text-gray-900">
                      {item?.employeeId?.name ? `${item?.employeeId?.name} (${item?.employeeId?.employeeId})` : (
                        <span className="text-orange-500">{t("UNASSIGNED")}</span>
                      )}
                    </td>                  
                    <td className="py-5 px-5 border-r text-gray-900">
                      {/* ═══ COLORED SHIFT NAME PILL ═══ */}
                      <span 
                        className="px-3 py-1 rounded-full text-xs font-medium inline-block"
                        style={{ backgroundColor: bgColor, color: textColor }}
                      >
                        {shiftName}
                      </span>
                    </td>
                    <td className="py-5 px-5 border-r text-gray-900">
                      {item?.locationId?.name || "N/A"}
                    </td>
                    <td className="py-5 px-5 border-r text-gray-900 text-center">
                      <div className="flex justify-center items-center gap-1">
                        <span className={`px-2 py-1 rounded-full text-xs ${
                          item?.status === 'published' ? 'bg-green-100 text-green-700' :
                          item?.status === 'draft' ? 'bg-gray-100 text-gray-700' :
                          item?.status === 'open' ? 'bg-orange-100 text-orange-700' :
                          'bg-blue-100 text-blue-700'
                        }`}>
                          {startCase(item?.status)}
                        </span>
                        {/* Swap Status Indicator */}
                        {item?.swapStatus === 'requested' && (
                          <span title={t("SWAP_PENDING")} className="px-2 py-0.5 rounded-full text-xs bg-purple-100 text-purple-700 flex items-center gap-1">
                            <AiOutlineSwap className="w-3 h-3" />
                          </span>
                        )}
                      </div>
                    </td>                  
                    <td className="py-5 px-5 border-r text-gray-900" title={`${dayjs(item?.startDateTime).format("MM-DD-YYYY HH:mm")} to ${dayjs(item?.endDateTime).format("MM-DD-YYYY HH:mm")}`}>
                      {dayjs(item?.startDateTime).format("MM-DD")} to {dayjs(item?.endDateTime).format("MM-DD")}
                    </td>
                    {/* <td className="py-5 px-5 border-r text-gray-900">{item?.startTime} to {item?.endTime}</td> */}
                    <td className="py-5 px-5 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY HH:mm")}</td>
                    <td className="py-5 px-5 border-l text-gray-900 text-center">
                      <ul className="flex justify-center">
                        <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title="Edit">
                            <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                          </a>
                        </li>
                        <li onClick={() => {
                          helpers.alertFunction(
                            `Are you sure want to delete '${item.name}'?`,
                            item._id,
                            handleDelete,
                            true
                          );
                        }} className="px-2 py-2 hover:bg-white hover:text-slate-800">
                          <a title="Delete">
                            <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
                          </a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                );
              })}
              {isEmpty(shiftList) && (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-5 px-5 border-r" colSpan={8}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ShiftList;





// import { AiFillEdit, AiFillDelete, AiFillEye, AiOutlineSwap } from "react-icons/ai";
// import { useTranslation } from "react-i18next";
// import dayjs from "dayjs";
// import { isEmpty, startCase } from "lodash";
// import helpers from "utils/helpers";

// const ShiftList = ({ shiftList, page, handleEdit, handleView, handleDelete }) => {
//   const { t } = useTranslation();

//   return (
//     <div>
//       <div className="p-3">
//         <div className="border overflow-x-auto relative rounded-lg">
//           <table className="text-left w-full text-xs text-[#A5A5A5] dark:text-gray-400">
//             <thead className="text-gray-900 text-xs border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <th scope="col" className="py-3 px-5">{t("EMPLOYEE")}</th>
//                 <th scope="col" className="px-5 py-3">{t("SHIFT_NAME")}</th>
//                 <th scope="col" className="py-3 px-5">{t("LOCATION")}</th>
//                 <th scope="col" className="text-center py-3 px-5">{t("STATUS")}</th>
//                 <th className="py-3 px-5" scope="col">{t("DATE")}</th>
//                 <th scope="col" className="py-3 px-5">{t("TIME")}</th>
//                 <th scope="col" className="text-center py-3 px-5">{t("O_CREATED_AT")}</th>
//                 <th className="py-3 px-5 text-center" scope="col">{t("O_ACTION")}</th>
//               </tr>
//             </thead>
//             <tbody>
//               {Array.isArray(shiftList) && shiftList?.map((item, i) => (
//                 <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-5 px-5 border-r text-gray-900">
//                     {item?.employeeId?.name ? `${item?.employeeId?.name} (${item?.employeeId?.employeeId})` : (
//                       <span className="text-orange-500">{t("UNASSIGNED")}</span>
//                     )}
//                   </td>                  
//                   <td className="py-5 px-5 border-r text-gray-900">
//                     {item?.name}
//                   </td>
//                   <td className="py-5 px-5 border-r text-gray-900">
//                     {item?.locationId?.name || "N/A"}
//                   </td>
//                   <td className="py-5 px-5 border-r text-gray-900 text-center">
//                     <div className="flex justify-center items-center gap-1">
//                       <span className={`px-2 py-1 rounded-full text-xs ${
//                         item?.status === 'published' ? 'bg-green-100 text-green-700' :
//                         item?.status === 'draft' ? 'bg-gray-100 text-gray-700' :
//                         item?.status === 'open' ? 'bg-orange-100 text-orange-700' :
//                         'bg-blue-100 text-blue-700'
//                       }`}>
//                         {startCase(item?.status)}
//                       </span>
//                       {/* Swap Status Indicator */}
//                       {item?.swapStatus === 'requested' && (
//                         <span title={t("SWAP_PENDING")} className="px-2 py-0.5 rounded-full text-xs bg-purple-100 text-purple-700 flex items-center gap-1">
//                           <AiOutlineSwap className="w-3 h-3" />
//                         </span>
//                       )}
//                     </div>
//                   </td>                  
//                   <td className="py-5 px-5 border-r text-gray-900" title={`${dayjs(item?.startDateTime).format("MM-DD-YYYY HH:mm")} to ${dayjs(item?.endDateTime).format("MM-DD-YYYY HH:mm")}`}>
//                     {dayjs(item?.startDateTime).format("MM-DD")} to {dayjs(item?.endDateTime).format("MM-DD")}
//                   </td>
//                   <td className="py-5 px-5 border-r text-gray-900">{item?.startTime} to {item?.endTime}</td>
//                   <td className="py-5 px-5 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY HH:mm")}</td>
//                   <td className="py-5 px-5 border-l text-gray-900 text-center">
//                     <ul className="flex justify-center">
//                       <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
//                         <a title="Edit">
//                           <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
//                         </a>
//                       </li>
//                       <li onClick={() => {
//                         helpers.alertFunction(
//                           `Are you sure want to delete '${item.name}'?`,
//                           item._id,
//                           handleDelete,
//                           true
//                         );
//                       }} className="px-2 py-2 hover:bg-white hover:text-slate-800">
//                         <a title="Delete">
//                           <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
//                         </a>
//                       </li>
//                     </ul>
//                   </td>
//                 </tr>
//               ))}
//               {isEmpty(shiftList) && (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-5 px-5 border-r" colSpan={8}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ShiftList;